import React, { Component } from "react";
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import DealsService from '../utils/DealsService';
import SeminarRegistrationsService from '../utils/SeminarRegistrationsService';
import SeminarsService from '../utils/SeminarsService';
import TrialCoachingSessionsService from '../utils/TrialCoachingSessionsService';



class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { dealStats: {}, registrationStats: {}, tcsStats: {} }
  }

  componentDidMount() {
    this.fetchStats()
  }

  fetchStats() {
    SeminarsService.index().then(data => {
      this.setState({ seminars: data.results, seminarStats: [] }, () => {
        this.state.seminars.filter((s) => s.status === 'open' || s.status === 'in_progress').forEach(seminar => {
          const currentStats = this.state.seminarStats
          SeminarRegistrationsService.stats(seminar.id).then((data) => {
            currentStats.push({ seminar: seminar, stats: data })
            this.setState({ seminarStats: currentStats })
          })
        });
      })
    })
    DealsService.stats().then(data => { this.setState({ dealStats: data }) })
    TrialCoachingSessionsService.stats().then(data => { this.setState({ tcsStats: data }) })
  }

  render() {
    const Stat = (props) => {
      const { number, text, link, alert, warning } = props
      let cname = "panel status panel-info"
      if (alert) cname = cname + " panel-danger"
      if (warning) cname = cname + " panel-warning"
      return (
        <div className="status-card">
          <Link to={link || '/m1/dashboard'}>
            <div className={cname}>
              <div className="panel-heading">
                <h1 className="panel-title text-center">{number || 0}</h1>
              </div>
              <div className="panel-body text-center">
                <strong>{text}</strong>
              </div>
            </div>
          </Link>
        </div>
      )
    }

    const { dealStats, tcsStats, seminarStats } = this.state

    return (
      <div>
        <div className="row">
          <div className="col-sm-12">

            <h3 className="status-card-header">Deals</h3>
            <div className="clearfix">
              <Stat number={dealStats.open} text="Open" link='/m1/deals/list/open' />
              <Stat number={dealStats.on_hold} text="On Hold" link='/m1/deals/list/on_hold' warning={dealStats.on_hold > 0} />
              <Stat number={dealStats.verification} text='Need Verification' link='/m1/deals/list/verification' warning={dealStats.verification > 0} />
              <Stat number={dealStats.upgrade} text='Need Upgrade' link='/m1/deals/list/upgrade' warning={dealStats.upgrade > 0} />
              <Stat number={dealStats.followup} text='Need QC Call' link='/m1/deals/list/followup' warning={dealStats.followup > 0} />
              <Stat number={dealStats.review} text='Need Review' link='/m1/deals/list/review' warning={dealStats.review > 0} />
            </div>
            <h3 className="status-card-header">Trial Coaching Sessions</h3>
            <div className="clearfix">
              <Stat number={tcsStats.today} text="Today" link='/m1/tcs/list/today' />
              <Stat number={tcsStats.week_ahead} text='Week Ahead' link='/m1/tcs/list/week_ahead' />
              <Stat number={tcsStats.month_ahead} text='Month Ahead' link='/m1/tcs/list/month_ahead' />
              <Stat number={tcsStats.overdue} text='Sale Overdue' alert={tcsStats.overdue > 0} link='/m1/tcs/list/overdue' />
              <Stat number={tcsStats.need_confirmation} text='Need Confirmation' alert={tcsStats.need_confirmation > 0} link='/m1/tcs/list/need_confirmation' />
              <Stat number={tcsStats.unassigned} text='Unassigned' alert={tcsStats.unassigned > 0} link='/m1/tcs/list/unassigned' />
            </div>

            <h3 className="status-card-header">Open Seminars <small>(booking now)</small></h3>
            {seminarStats && seminarStats.filter((stats) => stats.seminar.status === 'open').sort((a, b) => new Date(a.seminar.at) - new Date(b.seminar.at)).map((s) => {
              const { stats } = s
              return (
                stats && <React.Fragment key={s.seminar.id}>
                  <h3 key={s.seminar.id} className="status-card-header"><Link to={`/m1/seminars/${s.seminar.id}/registrations/all`}>{s.seminar.location}</Link> - <Moment format="h:mmA Do MMMM YYYY">{s.seminar.at}</Moment></h3>
                  <div className="clearfix">
                    <Stat number={stats.confirmation} text='Waiting Confirmation' link={`/m1/seminars/${s.seminar.id}/registrations/confirmation`} warning={stats.confirmation > 0} />
                    <Stat number={stats.attendance} text='Waiting Attendance' link={`/m1/seminars/${s.seminar.id}/registrations/attendance`} warning={stats.attendance > 0} />
                    <Stat number={stats.attended_no_tcs} text='Attended, No TCS' link={`/m1/seminars/${s.seminar.id}/registrations/attended_no_tcs`} alert={stats.attended_no_tcs > 0} />
                    <Stat number={stats.attended_tcs} text='Attended TCS' link={`/m1/seminars/${s.seminar.id}/registrations/attended_tcs`} />
                    <Stat number={stats.not_attended} text='Not Attended' link={`/m1/seminars/${s.seminar.id}/registrations/not_attended`} />
                    <Stat number={stats.cancelled} text='Cancelled' link={`/m1/seminars/${s.seminar.id}/registrations/cancelled`} />
                  </div>
                </React.Fragment>
              )
            })
            }
            <h3 className="status-card-header">In Progress Seminars <small>(after seminar activities)</small></h3>
            {seminarStats && seminarStats.filter((stats) => stats.seminar.status === 'in_progress').sort((a, b) => new Date(a.seminar.at) - new Date(b.seminar.at)).map((s) => {
              const { stats } = s
              return (
                stats && <React.Fragment key={s.seminar.id}>
                  <h3 key={s.seminar.id} className="status-card-header"><Link to={`/m1/seminars/${s.seminar.id}/registrations/all`}>{s.seminar.location}</Link> - <Moment format="h:mmA Do MMMM YYYY">{s.seminar.at}</Moment></h3>
                  <div className="row">
                    <Stat number={stats.confirmation} text='Waiting Confirmation' link={`/m1/seminars/${s.seminar.id}/registrations/confirmation`} warning={stats.confirmation > 0} />
                    <Stat number={stats.attendance} text='Waiting Attendance' link={`/m1/seminars/${s.seminar.id}/registrations/attendance`} warning={stats.attendance > 0} />
                    <Stat number={stats.attended_no_tcs} text='Attended, No TCS' link={`/m1/seminars/${s.seminar.id}/registrations/attended_no_tcs`} alert={stats.attended_no_tcs > 0} />
                    <Stat number={stats.attended_tcs} text='Attended TCS' link={`/m1/seminars/${s.seminar.id}/registrations/attended_tcs`} />
                    <Stat number={stats.not_attended} text='Not Attended' link={`/m1/seminars/${s.seminar.id}/registrations/not_attended`} />
                    <Stat number={stats.cancelled} text='Cancelled' link={`/m1/seminars/${s.seminar.id}/registrations/cancelled`} />
                  </div>
                </React.Fragment>
              )
            })
            }
          </div>
        </div>
      </div>
    );
  }
}
export default Dashboard